export const MAXIMUM_INSTALMENT_INPUT = 100_000
